import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle, taal }) => (
  <header
    style={{
      background: `cornflowerblue`,
      marginBottom: `1rem`,
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        
      }}
    >
      <h1 style={{ margin: 0, "text-align": `center` }}>
        <Link
          to={"/"+(taal==='nl'? '' : taal)}
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          {siteTitle}
        </Link>
		<div className="taalpanel">
		<Link className="taalswitch" to="/en">English</Link>/
		<Link className="taalswitch" to="/">Nederlands</Link>
		</div>
      </h1>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
